import { createContext, type Dispatch, type SetStateAction } from "react";
import type { Script, ScriptForm } from "@/features/dashboard/types";

export interface ManageParticipantsState {
  open: boolean;
  scriptForm: ScriptForm | null;
  scriptName: string;
}

export interface ShareDialogState {
  open: boolean;
  script: Script | null;
  scriptForm: ScriptForm | null;
}

export interface DashboardDialogsContextValue {
  showAddScript: boolean;
  openAddScript: () => void;
  closeAddScript: () => void;

  showSettings: boolean;
  openSettings: () => void;
  closeSettings: () => void;

  selectedScriptForm: { scriptForm: ScriptForm; scriptName: string; script: Script } | null;
  openAnalysisDialog: (scriptForm: ScriptForm, scriptName: string, script: Script) => void;
  closeAnalysisDialog: () => void;

  manageParticipantsState: ManageParticipantsState;
  openManageParticipants: (args: { scriptForm: ScriptForm; scriptName: string }) => void;
  closeManageParticipants: () => void;

  shareDialogState: ShareDialogState;
  openShareDialog: (script: Script, scriptForm: ScriptForm) => void;
  closeShareDialog: () => void;
  setShareDialogState: Dispatch<SetStateAction<ShareDialogState>>;
}

export const DashboardDialogsContext = createContext<DashboardDialogsContextValue | null>(null);
